module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "feedback-knowledge-js": "static-1.4065",
      "head-dlb": "static-1.3679",
      "hs-test-utils": "static-1.6627",
      "hubspot-dlb": "static-2.1317",
      "I18n": "static-7.1372",
      "jasmine-runner": "static-1.5023",
      "quartz": "static-1.5376",
      "react-dlb": "static-1.51",
      "outpost": "static-1.2962",
      "PatternValidationJS": "static-1.437",
      "react": "static-7.151",
      "enviro": "static-4.293",
      "hs-promise-rejection-tracking": "static-1.3967",
      "PortalIdParser": "static-2.272",
      "raven": "static-3.4440",
      "raven-hubspot": "static-1.4747",
      "classnames": "static-2.10",
      "hoist-non-react-statics": "static-3.9",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.2969",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8343",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "styled-components": "static-2.40",
      "moment": "static-3.26",
      "react-dom": "static-7.85",
      "HeadJS": "static-2.563",
      "foundations-components": "static-1.5790",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1738",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "webpack-env": "static-1.54",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "react-utils": "static-2.4180",
      "jasmine": "static-4.2973",
      "quartz-core-utils": "static-1.2243",
      "StyleGuideUI": "static-3.453",
      "quartz-core": "static-1.4595",
      "csstype": "static-1.38",
      "bend-plugin-foundations-components": "static-1.2058",
      "floating-ui": "static-1.28",
      "foundations-assets": "static-1.3540",
      "foundations-theming": "static-1.2934",
      "foundations-theming-specialty": "static-1.651",
      "hs-story-utils": "static-1.8016",
      "react-aria": "static-1.38",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.73",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.331",
      "ui-images": "static-2.805",
      "copilot-toolkit": "static-1.5610",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-janus": "static-1.635",
      "hub-http-shared-msw-handlers": "static-1.6849",
      "hubspotter-http": "static-1.3421",
      "hubspotter-http-shared-msw-handlers": "static-1.6847",
      "icons": "static-2.591",
      "mobile-manifest-mixins": "static-1.334",
      "platform-navigation-bootstrap": "static-1.11023",
      "quick-fetch": "static-1.2772",
      "react-rhumb": "static-1.15224",
      "react-router-dom": "static-5.26",
      "UIComponents": "static-3.7062",
      "bend-plugin-foundations-theming": "static-1.1417",
      "foundations-theming-base": "static-1.1919",
      "react-input-autosize": "static-2.17",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14851",
      "ts-schema": "static-1.2991",
      "sassPrefix": "static-1.129",
      "platform-infra-nav-components": "static-1.6540",
      "cssUtils": "static-1.459",
      "HubStyle": "static-2.10422",
      "HubStyleTokens": "static-2.10113",
      "hs-lodash": "static-4.45"
    },
    "depPathPrefixes": {
      "feedback-knowledge-js": "/feedback-knowledge-js/static-1.4065",
      "head-dlb": "/head-dlb/static-1.3679",
      "hs-test-utils": "/hs-test-utils/static-1.6627",
      "hubspot-dlb": "/hubspot-dlb/static-2.1317",
      "I18n": "/I18n/static-7.1372",
      "jasmine-runner": "/jasmine-runner/static-1.5023",
      "quartz": "/quartz/static-1.5376",
      "react-dlb": "/react-dlb/static-1.51",
      "outpost": "/outpost/static-1.2962",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react": "/react/static-7.151",
      "enviro": "/enviro/static-4.293",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
      "PortalIdParser": "/PortalIdParser/static-2.272",
      "raven": "/raven/static-3.4440",
      "raven-hubspot": "/raven-hubspot/static-1.4747",
      "classnames": "/classnames/static-2.10",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8343",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "styled-components": "/styled-components/static-2.40",
      "moment": "/moment/static-3.26",
      "react-dom": "/react-dom/static-7.85",
      "HeadJS": "/HeadJS/static-2.563",
      "foundations-components": "/foundations-components/static-1.5790",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1738",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "webpack-env": "/webpack-env/static-1.54",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "react-utils": "/react-utils/static-2.4180",
      "jasmine": "/jasmine/static-4.2973",
      "quartz-core-utils": "/quartz-core-utils/static-1.2243",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "quartz-core": "/quartz-core/static-1.4595",
      "csstype": "/csstype/static-1.38",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2058",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-assets": "/foundations-assets/static-1.3540",
      "foundations-theming": "/foundations-theming/static-1.2934",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.651",
      "hs-story-utils": "/hs-story-utils/static-1.8016",
      "react-aria": "/react-aria/static-1.38",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.73",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.331",
      "ui-images": "/ui-images/static-2.805",
      "copilot-toolkit": "/copilot-toolkit/static-1.5610",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-janus": "/hub-http-janus/static-1.635",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6849",
      "hubspotter-http": "/hubspotter-http/static-1.3421",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6847",
      "icons": "/icons/static-2.591",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.334",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11023",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-rhumb": "/react-rhumb/static-1.15224",
      "react-router-dom": "/react-router-dom/static-5.26",
      "UIComponents": "/UIComponents/static-3.7062",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1417",
      "foundations-theming-base": "/foundations-theming-base/static-1.1919",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14851",
      "ts-schema": "/ts-schema/static-1.2991",
      "sassPrefix": "/sassPrefix/static-1.129",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6540",
      "cssUtils": "/cssUtils/static-1.459",
      "HubStyle": "/HubStyle/static-2.10422",
      "HubStyleTokens": "/HubStyleTokens/static-2.10113",
      "hs-lodash": "/hs-lodash/static-4.45"
    },
    "project": "feedback-knowledge-js",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};